import config from '__api/config';
import { getSumCash, withDraw } from '__api/dsbc';
import { InvRewardDataVO } from '__api/dsbc/inv/getInvRewardList';
import { getUserRewardList } from '__api/dsbc/inv/getUserRewardList';
import { finishTask } from '__api/zqhd/FinishTask';
import { ShareButton } from '__components/ShareButton';
import { shareAdConfig } from '__constants/AdConfig';
import { AppShare } from '__utils/appShare';
import { openUrl } from '__utils/openUrl';
import { RootSiblingContainer } from 'emrn-design';
import { Dialog } from 'emrn-design/Dialog';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Toast } from 'emrn-design/Toast';
import { rpx } from 'emrn-design/rpx';
import { EmPageProps } from 'emrn-navigation';
import { AnimatedHeader } from 'emrn-navigation/AnimatedHeader';
import React, { Component } from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  NativeSyntheticEvent,
  NativeScrollEvent,
  Animated,
  ImageBackground,
  FlatList,
  Platform,
} from 'react-native';
import { DrawCashPop } from '../dialogPops/drawCashPop';
import { IsDrawCashPop } from '../dialogPops/isDrawCashPop';
import { SafeTipPop } from '../dialogPops/safeTipPop';
import { ShareTipPop } from '../dialogPops/shareTipPop';

/**
 * 状态
 */
interface WardRecordState {
  /**
   * y轴滑动位移
   */
  scrollY: Animated.Value;
  /**
   * 邀请好友总数
   */
  inviteAccount: string;
  /**
   * 可提现金额
   */
  availCash: string;
  /**
   * 已赚金额
   */
  sumCash: string;
  /**
   * 当月可提现金额
   */
  availCashMonth: string;
  /**
   * 实际操作可提取金额
   */
  availCashReal: string;
  /**
   * 本周可提取金额
   * */
  availCashWeek: string;
  /**
   * 最高可提取金额
   */
  topWithdrawCash: string;
  /**
   * 用户奖励记录数据
   */
  rewardRecordData: InvRewardDataVO[] | undefined;
}
export class WardRecord extends Component<EmPageProps, WardRecordState> {
  static displayName = 'WardRecord';
  private dialog = React.createRef<Dialog>();
  private toast = React.createRef<Toast>();
  private drawCashPop = React.createRef<DrawCashPop>();
  private isDrawCashPop = React.createRef<IsDrawCashPop>();
  private shareTipPop = React.createRef<ShareTipPop>();
  private safeTipPop = React.createRef<SafeTipPop>();

  constructor(props: EmPageProps) {
    super(props);
    this.state = {
      scrollY: new Animated.Value(0),
      inviteAccount: '0',
      availCash: '0',
      sumCash: '0',
      availCashMonth: '0',
      availCashReal: '0',
      topWithdrawCash: '0',
      availCashWeek: '0',
      rewardRecordData: [],
    };
  }
  componentDidMount() {
    this._getSumCash();
    this._getInvRewardListV1();
  }
  /**
   * 获取邀请累计人数金额
   */
  _getSumCash = async () => {
    try {
      //id: 赛项ID
      let res = await getSumCash({ invId: config.invId });
      if (res && res.IsSuccess) {
        this.setState({
          inviteAccount: res.Data?.invSucCnt || '',
          availCash: res.Data?.availCashTotal || '',
          sumCash: res.Data?.sumCash || '',
          availCashMonth: res.Data?.availCashMonth || '',
          availCashReal: res.Data?.availCashReal || '',
          availCashWeek: res.Data?.availCashWeek || '',
          topWithdrawCash: res.Data?.topWithdrawCash || '',
        });
      }
    } catch (error) {
      return;
    }
  };
  /**
   * 提现
   */
  _withDraw = async (cash: string, cb: Function) => {
    try {
      //id: 赛项ID
      let res = await withDraw({ invId: config.invId, cash: cash });
      if (res && res.IsSuccess) {
        cb && cb();
      } else {
        if ([6000, 6001, 6002, 6003, 6005, 6006].includes(res.StatusCode)) {
          this.safeTipPop.current?.show(res.Message, res.StatusCode);
        } else {
          this.dialog.current?.show(res.Message);
        }
      }
    } catch (error) {
      return;
    }
  };
  //获取用户奖励记录(点击用)
  _getInvRewardListV1 = async () => {
    try {
      let res = await getUserRewardList({
        invId: config.invId,
        pageNum: 1,
        pageSize: 100,
      });
      if (res && res.IsSuccess) {
        this.setState({
          rewardRecordData: res.Data,
        });
      }
    } catch (error) {
      return;
    }
  };
  //增加抽奖次数
  _finishTask = async (taskId: string) => {
    try {
      await finishTask({
        taskId,
      });
    } catch (e) {
      console.log(e);
    }
  };
  /*我的奖励按钮*/
  renderMypacketButton = () => {
    const styles = createStyles();
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(10), bottom: rpx(5), left: rpx(10), right: rpx(0) }}
        style={[styles.rightBtn, styles.rewardBtn]}
        activeOpacity={0.9}
        onPress={() => {
          openUrl(config.redPacketUrl);
        }}
      >
        <Text style={styles.ruleText}>钱包</Text>
      </EmTouchableOpacity>
    );
  };
  renderPercentCenterBtn = () => {
    const styles = createStyles();
    return (
      <EmTouchableOpacity
        hitSlop={{ top: rpx(5), bottom: rpx(10), left: rpx(10), right: rpx(0) }}
        style={[styles.rightBtn, styles.percentBtn]}
        activeOpacity={0.9}
        onPress={() => {
          if (Platform.OS === 'web') {
            return;
          }
          let url = '';
          if (Platform.OS === 'ios') {
            url = 'eastmoney://page/emrn?id=jfzx';
          } else {
            url = 'dfcft://emrn?id=jfzx';
          }
          openUrl(url);
        }}
      >
        <View style={{ marginTop: rpx(2) }}>
          <Text style={styles.ruleText}>积分</Text>
          <Text style={styles.ruleText}>中心</Text>
        </View>
      </EmTouchableOpacity>
    );
  };
  onScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { y } = event.nativeEvent.contentOffset;
    Animated.event([{ y: this.state.scrollY }])({ y });
  };
  render() {
    const styles = createStyles();
    const { scrollY, availCash, availCashReal, rewardRecordData, topWithdrawCash } = this.state;
    return (
      <RootSiblingContainer>
        <Animated.ScrollView style={styles.container} bounces={false} scrollEventThrottle={10} onScroll={this.onScroll}>
          <LinearGradient
            colors={['rgba(155, 242, 252,1)', 'rgba(149, 235, 250,1)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 0, y: 3 }}
          >
            <View style={{ flex: 1 }}>
              <View style={{ alignItems: 'center', height: rpx(380) }}>
                <ImageBackground
                  style={styles.headerBc}
                  source={require('../../images/invite/topbg.png')}
                  resizeMode={'stretch'}
                />
                <View style={styles.contentBox}>
                  <View style={styles.redPacketContent}>
                    <View>
                      <View style={{ paddingLeft: rpx(5) }}>
                        <Text style={styles.contentText}>{Number(availCashReal)?.toFixed(2) + '元'}</Text>
                      </View>
                      <Text style={styles.contentTitle}>本周可提现金额</Text>
                    </View>
                    <View>
                      <View style={{ paddingLeft: rpx(5), flexDirection: 'row' }}>
                        <Text style={[styles.contentText]}>{Number(availCash)?.toFixed(2) + '元'}</Text>
                      </View>
                      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={styles.contentTitle}>待提现金额</Text>
                        <EmTouchableOpacity
                          onPress={() => {
                            this.toast.current?.show('待提现金额=活动累计获得金额-已提现金额');
                          }}
                        >
                          <Image
                            style={styles.question_img}
                            source={require('../../images/invite/question2.png')}
                            resizeMode={'stretch'}
                          />
                        </EmTouchableOpacity>
                      </View>
                    </View>
                  </View>
                  {+availCash >= 1 ? (
                    <EmTouchableOpacity
                      style={{ marginTop: rpx(30) }}
                      activeOpacity={0.9}
                      onPress={() => {
                        if (+availCash < 1) {
                          this.toast.current?.show('本周可提现金额不足1元，无法提现。');
                          return;
                        }
                        this.isDrawCashPop.current?.show();
                      }}
                    >
                      <LinearGradient
                        style={styles.getMoneyBtn}
                        angle={0}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 0, y: 1 }}
                        colors={['#FE2011', '#FF9073']}
                      >
                        <Text style={styles.getMoneyBtnText}>立即提现</Text>
                      </LinearGradient>
                    </EmTouchableOpacity>
                  ) : (
                    <EmTouchableOpacity
                      style={{ marginTop: rpx(30) }}
                      activeOpacity={0.9}
                      onPress={() => {
                        if (+availCash < 1) {
                          this.toast.current?.show('本周可提现金额不足1元，无法提现');
                          return;
                        }
                        this.isDrawCashPop.current?.show();
                      }}
                    >
                      <LinearGradient
                        style={[styles.getMoneyBtn, styles.getMoneyBtn2]}
                        angle={0}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 0, y: 1 }}
                        colors={['#FE2011', '#FF9073']}
                      >
                        <Text style={styles.getMoneyBtnText}>立即提现</Text>
                      </LinearGradient>
                    </EmTouchableOpacity>
                  )}
                  <View style={{ flexDirection: 'row', marginTop: rpx(12) }}>
                    <Text style={styles.bottomText1}>满1元即可提现，每周最高可提现{topWithdrawCash || '100'}元</Text>
                  </View>
                </View>
              </View>
              <View style={styles.wordRecordList}>
                <View style={styles.wardRecord}>
                  <View style={{ marginTop: rpx(24) }}>
                    <Text style={styles.recordTitle}>奖励记录</Text>
                  </View>
                  <View style={styles.wardRecordContent}>
                    <Text style={styles.columnTitle}>时间</Text>
                    <Text style={styles.columnTitle}>奖品</Text>
                  </View>
                  <FlatList
                    data={rewardRecordData}
                    nestedScrollEnabled
                    renderItem={({ item }) => (
                      <View style={styles.wardRecordContent}>
                        <Text style={styles.columnDate}>{item.rwdDate}</Text>
                        <Text style={styles.columnWardTitle}>{item.reward}</Text>
                      </View>
                    )}
                    ListEmptyComponent={() => {
                      return <Text style={styles.noData}>暂无记录</Text>;
                    }}
                    ItemSeparatorComponent={() => {
                      return <View style={styles.separatorLine} />;
                    }}
                  />
                </View>
              </View>
            </View>
          </LinearGradient>
        </Animated.ScrollView>
        <AnimatedHeader
          title={'现金奖励'}
          scrollY={scrollY}
          titleColor="#333333"
          backTheme={'black'}
          normalBackgroundColor="#7de1f0"
          transparentBackgroundColor="rgba(227,103,38,0)"
          titleRight={() => {
            return (
              <ShareButton
                onPress={async () => {
                  const res = await AppShare({
                    trackCode: 'csj.gxyxhdy.ysj.fxqd',
                    groupCode: shareAdConfig.common.code,
                  });
                  if (res) {
                    this._finishTask('cw_05');
                  }
                  setTimeout(() => {
                    res && this.shareTipPop.current?.show();
                  }, 200);
                }}
              />
            );
          }}
        />
        <Toast ref={this.toast} />
        {this.renderMypacketButton()}
        {this.renderPercentCenterBtn()}
        <IsDrawCashPop
          ref={this.isDrawCashPop}
          money={Number(availCashReal)}
          onPress={() => {
            let money = Number(availCashReal).toFixed(2);
            this.isDrawCashPop.current?.hide();
            //执行提现操作
            this._withDraw(money, () => {
              this.drawCashPop.current?.show(money);
              // this._finishTask('cw_16');
            });
          }}
        />
        <DrawCashPop
          ref={this.drawCashPop}
          onPress={async () => {
            this._getSumCash();
            this.drawCashPop.current?.hide();
          }}
        />
        <ShareTipPop
          ref={this.shareTipPop}
          onPress={() => {
            const { push } = this.props.navigation;
            push('Invite', { toScroll: true });
          }}
        />
        <Dialog ref={this.dialog} />
        <SafeTipPop ref={this.safeTipPop} />
      </RootSiblingContainer>
    );
  }
}
function createStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: 'rgba(149, 235, 250,1)',
      height: '100%',
    },
    headerBc: {
      width: rpx(375),
      height: rpx(165),
      alignItems: 'center',
      justifyContent: 'center',
    },
    contentBox: {
      alignItems: 'center',
      marginTop: rpx(-80),
      width: rpx(345),
      backgroundColor: '#fff',
      height: rpx(210),
      borderRadius: rpx(12),
    },
    redPacketContent: {
      justifyContent: 'space-around',
      width: rpx(345),
      marginTop: rpx(34),
      paddingLeft: rpx(24),
      flexDirection: 'row',
    },
    contentTitle: {
      fontSize: rpx(12),
      color: '#999999',
      lineHeight: rpx(20),
      marginTop: rpx(12),
    },
    contentText: {
      fontSize: rpx(18),
      color: '#FF2233',
      fontWeight: 'bold',
      lineHeight: rpx(20),
    },
    question_img: {
      marginTop: rpx(12),
      width: rpx(15),
      height: rpx(15),
      marginLeft: rpx(2),
    },
    getMoneyBtn: {
      alignItems: 'center',
      width: rpx(260),
      height: rpx(50),
      justifyContent: 'center',
      borderRadius: rpx(25),
    },
    getMoneyBtn2: {
      opacity: 0.5,
    },
    getMoneyBtnText: {
      fontSize: rpx(18),
      color: '#fff',
      fontWeight: 'bold',
      lineHeight: rpx(40),
    },
    bottomText1: {
      fontSize: rpx(12),
      color: '#999999',
      lineHeight: rpx(14),
    },
    bottomText2: {
      fontSize: rpx(12),
      color: '#FF5500',
      lineHeight: rpx(14),
      fontWeight: 'bold',
    },
    recordTitle: {
      fontSize: rpx(18),
      color: '#333333',
      fontWeight: 'bold',
    },
    wardRecord: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      width: rpx(343),
      backgroundColor: '#fff',
      borderRadius: rpx(24),
      paddingBottom: rpx(15),
      marginBottom: rpx(10),
    },
    wardRecordTitle: {
      width: rpx(188),
      height: rpx(36),
    },
    wardRecordContent: {
      width: rpx(300),
      height: rpx(46),
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: rpx(24),
      paddingRight: rpx(24),
    },
    columnTitle: {
      fontSize: rpx(14),
      color: '#5F2818',
      lineHeight: rpx(46),
      textAlign: 'center',
      marginRight: rpx(20),
    },
    columnWardTitle: {
      fontSize: rpx(14),
      color: '#5F2818',
      lineHeight: rpx(46),
      textAlign: 'center',
    },
    columnDate: {
      fontSize: rpx(13),
      color: '#5F2818',
      lineHeight: rpx(46),
    },
    noData: {
      textAlign: 'center',
      marginTop: rpx(50),
    },
    separatorLine: {
      width: rpx(300),
      height: rpx(1),
      backgroundColor: '#eeeeee',
      marginLeft: rpx(24),
      opacity: 0.5,
    },
    rightBtn: {
      position: 'absolute',
      right: rpx(12),
      width: rpx(32),
      height: rpx(32),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 136, 199,0.5)',
      borderRadius: rpx(16),
    },
    /* 我的奖励 */
    rewardBtn: {
      top: Platform.select({
        web: rpx(100),
        android: rpx(100),
        ios: rpx(100),
      }),
    },
    percentBtn: {
      top: Platform.select({
        web: rpx(150),
        android: rpx(150),
        ios: rpx(150),
      }),
    },
    ruleText: {
      fontSize: rpx(10),
      color: '#fff',
      lineHeight: rpx(12),
      textAlign: 'center',
    },
    wordRecordList: {
      alignItems: 'center',
      height: rpx(500),
      marginTop: rpx(-60),
    },
  });
}
